import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { classNames } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { MultiSelect } from './private/controls/MultiSelect';
import { AutocompleteMultiSelect } from './private/controls/AutocompleteMultiSelect';
import './FormMultiSelect.scss';
/**
 * @component FormMultiSelect
 * @since 1.0.0
 */
export function FormMultiSelect(props) {
    let { name, size, style, picto, badge, label, infos, error, options, required, optional, disabled, placeholder, defaultValue, tooltip, prefix, suffix, search } = Object.assign({ style: 'normal', picto: 'chevron-down', placeholder: t('Choose') }, props);
    const form = useForm();
    const [ident] = useIdent('form-multi-select');
    const [values, setValues] = useValue(name, props.value, defaultValue || []);
    const [focused, setFocused] = useState(false);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValues(value);
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(values);
        }
    }, [values]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-multi-select', 'form-multi-select--' + size, 'form-multi-select--' + style, { 'form-multi-select--is-required': required }, { 'form-multi-select--is-optional': optional }, { 'form-multi-select--is-disabled': disabled }, { 'form-multi-select--is-focused': focused }, { 'form-multi-select--has-label': label }, { 'form-multi-select--has-value': values }, { 'form-multi-select--has-picto': picto }, { 'form-multi-select--has-badge': badge }, { 'form-multi-select--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-multi-select-field" },
            React.createElement("div", { className: "form-multi-select-field-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-multi-select-label", size: size, style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-multi-select-infos", size: size, style: style, infos: infos }))),
            React.createElement("div", { className: "form-multi-select-field-body" },
                prefix && React.createElement("div", { className: "form-multi-select-prefix" }, prefix),
                !search ? (React.createElement(MultiSelect, { name: name, ident: ident, values: values, options: options, required: required, disabled: disabled, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, onChange: onChange })) : (React.createElement(AutocompleteMultiSelect, { name: name, ident: ident, values: values, options: options, required: required, disabled: disabled, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, onChange: onChange })),
                picto && React.createElement(Icon, { className: "form-multi-select-picto", value: picto }),
                badge && React.createElement(Text, { className: "form-multi-select-badge", value: badge }),
                suffix && React.createElement("div", { className: "form-multi-select-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
}
